import React from "react";
import { formatDate, truncateDescription } from "../utils";
import { NewsItem } from "../common/types";
import ReactMarkdown from "react-markdown";

interface HighlightCardProps {
  news: NewsItem;
  onClick: (article: NewsItem) => void;
}

const HighlightCard: React.FC<HighlightCardProps> = ({ news, onClick }) => (
  <div
    className="bg-white dark:bg-gray-800 rounded-lg p-4 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 border"
    onClick={() => onClick(news)}
  >
    <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-white">
      {news.title}
    </h3>
    <div className="text-sm text-gray-600 dark:text-gray-300 mb-2">
      <ReactMarkdown>
        {truncateDescription(news.description, 150)}
      </ReactMarkdown>
    </div>
    <p className="text-xs text-gray-500 dark:text-gray-400">
      {formatDate(news.launch_date)}
    </p>
    <div className="mt-2 flex flex-wrap gap-2">
      {news.tags.slice(0, 3).map((tag: string, index: number) => (
        <span
          key={index}
          className="inline-block text-xs bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 px-2 py-1 rounded"
        >
          {tag}
        </span>
      ))}
    </div>
  </div>
);

export default HighlightCard;
